export enum DeckCategory {
  FINANCIAL = "FINANCIAL",
  LEGACY = "LEGACY",
  RELATIONSHIP = "RELATIONSHIP",
  EXPERIENCE = "EXPERIENCE",
}
